<template>
    <main class="error-page">
        <h1>403</h1>

        <h2>Acesso não autorizado</h2>

        <p>
            Não tem permissões para aceder a esta página.
        </p>

        <v-btn
            color="primary"
            :to="{ name: 'dashboard' }"
        >
            Voltar ao início
        </v-btn>
    </main>
</template>

<style scoped>
.error-page {
    display: grid;
    justify-items: center;
    gap: 1rem;
    padding: 4rem 1.5rem;
    text-align: center;
}
</style>